import { actionChannel } from 'redux-saga/effects'
import { types } from '../types'


const initialState = {

    saveCompanyInfoWaiting: false,
    saveCompanyInfoSuccess: false,
    saveCompanyInfoError: '',

    getCompanyInfoWaiting: false,
    getCompanyInfoSuccess: false,
    getCompanyInfoError: '',
    companyInfo: {}

}

const companyReducer = (state = initialState, { type, action, error }) => {
    switch (type) {
        //********************************************************************************** */
        case types.COMPANY_INFO_SAVE_REQUEST: {
            return {
                ...state,
                saveCompanyInfoWaiting: true,
                saveCompanyInfoSuccess: false,
                saveCompanyInfoError: '',
            }
        }
        case types.COMPANY_INFO_SAVE_SUCCESS: {
            return {
                saveCompanyInfoWaiting: false,
                saveCompanyInfoSuccess: true,
                saveCompanyInfoError: '',
            }
        }
        case types.COMPANY_INFO_SAVE_ERROR: {
            return {
                saveCompanyInfoWaiting: false,
                saveCompanyInfoSuccess: false,
                saveCompanyInfoError: '',
            }
        }
        //*********************************************************************************** */
        case types.GET_COMPANY_INFO_REQUEST: {
            return {
                ...state,
                getCompanyInfoWaiting: true,
                getCompanyInfoSuccess: false,
                getCompanyInfoError: '',
            }
        }
        case types.GET_COMPANY_INFO_SUCCESS: {
            return {
                getCompanyInfoWaiting: false,
                getCompanyInfoSuccess: true,
                getCompanyInfoError: '',
                companyInfo: action.data
            }
        }
        case types.GET_COMPANY_INFO_ERROR: {
            return {
                getCompanyInfoWaiting: false,
                getCompanyInfoSuccess: false,
                getCompanyInfoError: '',
            }
        }
        //************************************************************************************** */
        case types.COMPANY_INFO_RESET_PROPS: {
            return {
                ...state,
                getCompanyInfoWaiting: false,
                getCompanyInfoSuccess: false,
                getCompanyInfoError: '',
                companyInfo: {},

                saveCompanyInfoWaiting: false,
                saveCompanyInfoSuccess: false,
                saveCompanyInfoError: '',


            }
        }
        default:
            return state
    }

}


export default companyReducer;